<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">{{ "GENERAL" | translate }}</h6>
      @if(authService.isAuthorized([PermissionsEnum.Alarms_events_view])){
      <div class="sidemenu-item-font item" (click)="navigate('events/events')"
        [ngClass]="{ selected: isActive('events/events') }">
        <span>{{ "SIDEBAR_EVENTS" | translate }}</span>
      </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Alarms_realtime_view])){
      <div class="sidemenu-item-font item" (click)="navigate('events/alarms')"
        [ngClass]="{ selected: isActive('events/alarms') }">
        <span>{{ "ALARMS" | translate }}</span>
      </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Alarms_ondemand_view])){
      <div class="sidemenu-item-font item" (click)="navigate('events/on-demand')"
        [ngClass]="{ selected: isActive('events/on-demand') }">
        <span>{{ "ONDEMAND" | translate }}</span>
      </div>
      }
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>